// Hi-Fry loader (generated). Loads the hashed app bundle beside this file.
import('./hifry-app-BXEWaT_F.js');
